module.exports = __webpack_public_path__ + "img/kaaba.e5710ede.svg";